<div [ngClass]="getNavClass()">
  <ol class="steps__list">
    <li
      *ngFor="let navTab of navTabs; let i = index"
      [ngClass]="getNavTabClass(navTab)"
      class="steps__item"
      (click)="i === 0 ? removeReferal() : null"
    >
      <ng-container *ngIf="!navTab.link">
        <span class="steps__item-number">
          {{ navTab.numberTranslateKey | translate }}
        </span>
        <span class="steps__item-text">
          {{ navTab.textTranslateKey | translate }}
        </span>
      </ng-container>

      <a *ngIf="navTab.link" [routerLink]="[navTab.link]">
        <span class="steps__item-number">
          {{ navTab.numberTranslateKey | translate }}
        </span>
        <span class="steps__item-text">
          {{ navTab.textTranslateKey | translate }}
        </span>
      </a>
    </li>
  </ol>
  <div
    (click)="openDateModal()"
    class="steps__sidebar-date-container"
    *ngIf="bookingData?.startDate"
  >
    <div>
      <div>{{ bookingData?.startDate | localizedDate: 'dd MMM' }}</div>
      <div>{{ bookingData?.startDate | date: 'HH:mm':TIMEZONE_UTC_START }}</div>
    </div>
    <div class="steps__sidebar-toggle"></div>
    <div>
      <div>{{ bookingData?.endDate | localizedDate: 'dd MMM' }}</div>
      <div>{{ bookingData?.endDate | date: 'HH:mm':TIMEZONE_UTC_END }}</div>
    </div>
  </div>
  <div class="steps__sidebar-toggle-container">
    <button
      *ngIf="showSummaryButton"
      (click)="onClickSummary()"
      id="show-sidebar-drawer"
      class="steps__sidebar-toggle"
    >
      {{ 'navTab.summary' | translate }}
    </button>
    <span *ngIf="offerData.offer?.price" class="steps__sidebar-toggle-price"
      >{{ offerData?.offer?.price | number: '1.2-2'
      }}{{ 'common.euro' | translate }}</span
    >
  </div>
</div>
<bkg-voucher-banner [offerData]="offerData"></bkg-voucher-banner>
